import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { FilterId } from '../../filters/types/filters';

export const postingDiscovery: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.POSTING_DISCOVERY,
  revelioPageId: RevelioPageId.POSTING_DISCOVERY,
  // Default page name; the new UI header overrides the displayed leaf to
  // "Postings" so the breadcrumb reads "Discovery > Postings" there.
  name: 'Posting Discovery',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'posting-discovery-default',
      label: 'Posting Discovery',
      isActive: true,
      tabContent: {
        id: 'posting-discovery-default',
        grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
        secondaryFilters: [
          { id: FilterId.MULTI_COMPANY },
          { id: FilterId.MULTI_INDUSTRY },
          { id: FilterId.MULTI_GEOGRAPHY },
          { id: FilterId.MULTI_ROLE },
          { id: FilterId.MULTI_CUSTOM_SKILL },
          { id: FilterId.MULTI_ACTIVITY },
          { id: FilterId.MULTI_SENIORITY },
          { id: FilterId.MULTI_REMOTE_TYPE },
          { id: FilterId.MULTI_PAY },
          { id: FilterId.MULTI_TITLE },
          { id: FilterId.MULTI_KEYWORDS },
          { id: FilterId.POST_DATE },
        ],
        items: [
          {
            id: 'posting-discovery-table',
            title: 'Results',
            position: {
              x: 0,
              y: 0,
              width: DEFAULT_GRID_COLUMNS / 2,
              height: DEFAULT_GRID_ROWS,
            },
            plot: {
              chartType: 'table',
              defaultMetricOptions: ['td_users'],
              enableRowSelection: true,
              showZebraStripe: true,
              tableRowPopout: {
                chartType: 'full-profile-info',
              },
            },
          },
          {
            id: 'posting-discovery-map',
            title: '',
            position: {
              x: DEFAULT_GRID_COLUMNS / 2,
              y: 0,
              width: DEFAULT_GRID_COLUMNS / 2,
              height: DEFAULT_GRID_ROWS,
            },
            plot: {
              chartType: 'map',
              defaultMetricOptions: ['td_users'],
              mapOptions: {
                normalization: 'area_density',
                transformation: 'sqrt',
              },
              color: '#5BD992',
            },
          },
        ],
      },
    },
  ],
};
